(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'react-emotion', './index.css', './Tab'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('react-emotion'), require('./index.css'), require('./Tab'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactEmotion, global.index, global.Tab);
    global.index = mod.exports;
  }
})(this, function (exports, _react, _reactEmotion, _index, _Tab) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _index2 = _interopRequireDefault(_index);

  var _Tab2 = _interopRequireDefault(_Tab);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var getTabWidthClass = function getTabWidthClass(tabCount) {
    switch (tabCount) {
      case 1:
        return _index2.default.oneTab;
      case 2:
        return _index2.default.twoTab;
      case 3:
        return _index2.default.threeTab;
      case 4:
        return _index2.default.fourTab;
      default:
        return _index2.default.twoTab;
    }
  };

  var Tabber = function Tabber(_ref) {
    var tabs = _ref.tabs;

    var tabWidthClass = getTabWidthClass(tabs.length);

    return _react2.default.createElement(
      'div',
      { className: _index2.default.tabberWrapper },
      tabs.map(function (tab) {
        return _react2.default.createElement(_Tab2.default, {
          key: tab.id,
          id: tab.id,
          icon: tab.icon,
          label: tab.label,
          labelSubText: tab.labelSubText,
          onClickHandler: tab.onClickHandler,
          lockedOnClickHandler: tab.lockedOnClickHandler,
          isActive: tab.isActive,
          tabWidth: tabWidthClass,
          centerLabel: tab.centerLabel,
          isLocked: tab.isLocked
        });
      })
    );
  };

  exports.default = Tabber;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Tabber/index.js
// module id = 885
// module chunks = 1